import { render } from "./RegionSelectForm.vue?vue&type=template&id=9c796516&ts=true"
import script from "./RegionSelectForm.vue?vue&type=script&lang=ts"
export * from "./RegionSelectForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__